import { Field, Formik } from 'formik';
import { phoneRegExp } from 'helpers/utils';
import React from 'react';
import { Row, Col, FormGroup, FormLabel, Button, Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import emailjs from '@emailjs/browser';
import Input from 'components/common/form/input/Input';

interface Props {
  show: boolean;
  onClose: () => void;
}

const validationSchema = Yup.object({
  username: Yup.string().required('Full name is required'),
  companyName: Yup.string().required('Company / Organization is required'),
  phoneNumber: Yup.string()
    .matches(phoneRegExp, 'Phone number is not valid')
    .required('Phone is required'),
  contactEmail: Yup.string()
    .email('Invalid email address')
    .required('Company email is required')
});

const BookDemoModal = ({ show, onClose }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = (values: any, resetForm: any) => {
    const serviceId = process.env.REACT_APP_MAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_MAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_MAILJS_PUBLIC_KEY;

    if (serviceId && templateId && publicKey) {
      emailjs
        .send(serviceId, templateId, values, {
          publicKey
        })
        .then(
          () => {
            console.log('SUCCESS!');
            resetForm();
          },
          (error: { text: string }) => {
            console.log('FAILED...', error.text);
            resetForm();
          }
        );
    }
  };

  return (
    <Modal show={show} onHide={onClose} className="p-0" size="lg" centered>
      <Modal.Body className="p-4">
        <Row>
          <Col lg={7} className="book-demo-form_modal d-none d-lg-block">
            <div className="book-demo-form_container w-100 h-100 rounded-3">
              <div className="d-flex flex-column justify-content-end h-100 gap-2 ps-4 py-4 pe-14">
                <div className="text-white fs-7 fw-bold">
                  Ready to Elevate Your Recruitment Game?
                </div>
                <div className="text-white fs-8">
                  Book a Personalized Demo Today!
                </div>
                <div className="text-white fs-9">
                  Discover how CRUD Beat can transform your hiring process,
                  connect you with top-tier talent, and streamline every stage
                  of recruitment. Fill out the form below, and let’s get started
                  on creating opportunities that drive success.
                </div>
              </div>
            </div>
          </Col>
          {/* Form Section */}
          <Col lg={5} md={12} sm={12}>
            <div className="rounded">
              <Formik
                initialValues={{
                  username: '',
                  companyName: '',
                  phoneNumber: '',
                  contactEmail: ''
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { resetForm }) =>
                  handleSubmit(values, resetForm)
                }
              >
                {({ handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <Row className="g-5">
                      <Col lg={12}>
                        <FormGroup className="text-start">
                          <FormLabel htmlFor="username">Full name*</FormLabel>
                          <Field as={Input} name="username" id="username" />
                        </FormGroup>
                      </Col>
                      <Col lg={12}>
                        <FormGroup className="text-start">
                          <FormLabel htmlFor="companyName">
                            Company / Organization*
                          </FormLabel>
                          <Field
                            as={Input}
                            name="companyName"
                            id="companyName"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={12}>
                        <FormGroup className="text-start">
                          <FormLabel htmlFor="phoneNumber">Phone*</FormLabel>
                          <Field
                            as={Input}
                            name="phoneNumber"
                            id="phoneNumber"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={12}>
                        <FormGroup className="text-start">
                          <FormLabel htmlFor="contactEmail">Email*</FormLabel>
                          <Field
                            as={Input}
                            name="contactEmail"
                            id="contactEmail"
                            type="email"
                            placeholder="name@example.com"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      variant="primary"
                      className="px-6 rounded-2 mt-6 w-100 w-md-auto"
                      type="submit"
                      aria-label="Submit the form"
                    >
                      Book Now
                    </Button>
                  </form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default BookDemoModal;
